module.exports = __webpack_public_path__ + "static/media/boomwriter-logo.9bda31c6.svg";